import { render, staticRenderFns } from "./PersonSelect.vue?vue&type=template&id=26c60b2a&scoped=true&"
import script from "./PersonSelect.vue?vue&type=script&lang=ts&"
export * from "./PersonSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c60b2a",
  null
  
)

export default component.exports